module.exports = __webpack_public_path__ + "themes/mf/img/flake.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/flake.png
// module id = 73
// module chunks = 3